export enum FileSelectionType {
    File = 1,
    Directory = 2,
    All = File | Directory
}
